import type {Recipe} from './types';

export const ciambellaBolognese: Recipe = {
    id: 11,
    key: "ciambellaBolognese",
    pictures: [
        {index: 0, url: "https://www.odino.com/wp-content/uploads/2015/10/Brazadela-700x510.jpg"},
    ],
    video: "https://youtu.be/D_vtv_8magg?si=z7deXAcF9K1QpIca",
    i18n: {
        IT: {
            title: "Ciambella Bolognese",
            servings: "1 ciambella grande",
            ingredients: [
                "500 gr di farina",
                "150 gr di latte ",
                "150 gr di burro ",
                "150 gr di zucchero",
                "1 gr di sale ",
                "1 bustina di lievito per dolci",
                "2 uova ",
                "1 bustina di zucchero vanigliato",
                "1 bustina di zuccherini ",
                "1 barattolo di ciliegie sciroppate",
            ],
            steps: [
                "Sciogliere il burro in un pentolino a fuoco lento evitando che frigga o faccia odore",
                "Mettere tutte le componenti solide in una terrina",
                "Unire latte, burro e uova",
                "Rimescolare il tutto (l’ordine degli ingredienti non e’ importante, ma ricordare che le uova a contatto con il burro caldo si cuociono e l’albume si monta a contatto con lo zucchero)",
                "Quando il composto è pronto (non rimescolare troppo, basta che risulti tutto amalgamato)",
                "Arrotolare leggermente con le mani il composto facendolo diventare come un tubo",
                "Stendere velocemente su carta da forno in una teglia per il lungo schiacciandolo un po’",
                "Spalmare con un pennello imbevuto nel latte la superficie",
                "Decorare con zuccherini e ciliegie sciroppate",
                "Mettere in forno a 170 gradi 40 min ventilato nel piano al centro",
                "Girare dopo 20 minuti nel verso opposto per cottura omogenea",
                "Le tempistiche possono variare a seconda del forno quindi è importante controllare la parte interna della ciambella o con uno stuzzicadente o con la lama di un coltello appoggiandola tra le crepe che si formeranno in cottura.",
                "Per una cottura ottimale consiglio di abbassare la temperatura a 100-120 gradi quando la ciambella raggiunge un colore dorato ma non troppo scuro. Così facendo si asciugherà all’interno senza bruciarsi all’esterno.",
            ],
            notes: "Il tempo di cottura può variare a seconda del forno quindi è importante controllare la parte interna della ciambella con uno stuzzicadenti o con la lama di un coltello appoggiandola tra le crepe che si formeranno in cottura.\nPer una cottura ottimale consiglio di abbassare la temperatura a 100-120 gradi quando la ciambella raggiunge un colore dorato ma non troppo scuro. \nCosì facendo si asciugherà all’interno senza bruciarsi all'esterno.",
        },
        EN: {
            title: "Bolognese Cake",
            servings: "1 large ring cake",
            ingredients: [
                "500 g of flour",
                "150 g of milk",
                "150 g of butter",
                "150 g of sugar",
                "1 g of salt",
                "1 sachet of baking powder",
                "2 eggs",
                "1 sachet of vanilla sugar",
                "1 sachet of sugar sprinkles",
                "1 jar of candied cherries",
            ],
            steps: [
                "Melt the butter in a saucepan over low heat, avoiding frying or creating any odor.",
                "Put all the dry ingredients in a bowl.",
                "Add the milk, butter, and eggs.",
                "Mix everything together (the order of the ingredients is not important, but remember that eggs in contact with hot butter will cook, and egg whites will whip in contact with sugar).",
                "When the mixture is ready (do not overmix, just ensure everything is combined),",
                "Lightly roll the mixture with your hands into a tube shape.",
                "Quickly spread it on baking paper on a baking tray, flattening it slightly.",
                "Brush the surface with a brush dipped in milk.",
                "Decorate with sugar sprinkles and candied cherries.",
                "Bake in a fan oven at 170 degrees for 40 minutes, placing it in the middle rack.",
                "Turn the cake after 20 minutes for even baking.",
            ],
            notes: "Baking times may vary depending on the oven, so it's important to check the inside of the cake with a toothpick or knife blade, placing it in the cracks that form during baking.\nFor optimal baking, I recommend lowering the temperature to 100-120 degrees when the cake reaches a golden but not too dark color. This way, it will dry out inside without burning on the outside.\nBaking time may vary depending on the oven, so it is important to check the inside of the ring cake with a toothpick or the blade of a knife, placing it in the cracks that will form during baking. For optimal baking, I recommend lowering the temperature to 100-120 degrees when the cake reaches a golden but not too dark color. This way, it will dry out inside without burning on the outside.",
        },
        PL: {
            title: "Bolońskie Ciasto Pierścieniowe",
            servings: "1 duże ciasto pierścieniowe",
            ingredients: [
                "500 g mąki",
                "150 g mleka",
                "150 g masła",
                "150 g cukru",
                "1 g soli",
                "1 saszetka proszku do pieczenia",
                "2 jajka",
                "1 saszetka cukru waniliowego",
                "1 saszetka cukrowych posypek",
                "1 słoik kandyzowanych wiśni",
            ],
            steps: [
                "Rozpuścić masło w rondelku na małym ogniu, unikając smażenia lub wydzielania zapachu.",
                "Wszystkie suche składniki umieścić w misce.",
                "Dodać mleko, masło i jajka.",
                "Wymieszać wszystko razem (kolejność składników nie jest ważna, ale pamiętaj, że jajka w kontakcie z gorącym masłem się gotują, a białka ubijają w kontakcie z cukrem).",
                "Kiedy masa jest gotowa (nie mieszać zbyt długo, wystarczy, aby wszystko się połączyło),",
                "Delikatnie zrolować masę w dłoniach, tworząc kształt tuby.",
                "Szybko rozwałkować na papierze do pieczenia na blasze, lekko spłaszczając.",
                "Posmarować powierzchnię pędzelkiem zanurzonym w mleku.",
                "Ozdobić cukrowymi posypkami i kandyzowanymi wiśniami.",
                "Piec w piekarniku z termoobiegiem w temperaturze 170 stopni przez 40 minut, umieszczając na środkowej półce.",
                "Po 20 minutach obrócić ciasto w przeciwnym kierunku dla równomiernego pieczenia.",
            ],
            notes: "Czas pieczenia może się różnić w zależności od piekarnika, więc ważne jest, aby sprawdzić wnętrze ciasta wykałaczką lub ostrzem noża, wkładając je w pęknięcia, które powstają podczas pieczenia.\nDla optymalnego pieczenia zalecam obniżenie temperatury do 100-120 stopni, gdy ciasto osiągnie złoty, ale niezbyt ciemny kolor. W ten sposób wyschnie w środku, nie przypalając się na zewnątrz.\nCzas pieczenia może się różnić w zależności od piekarnika, więc ważne jest, aby sprawdzić wnętrze ciasta wykałaczką lub ostrzem noża, wkładając je w pęknięcia, które powstają podczas pieczenia. Dla optymalnego pieczenia zalecam obniżenie temperatury do 100-120 stopni, gdy ciasto osiągnie złoty, ale niezbyt ciemny kolor. W ten sposób wyschnie w środku, nie przypalając się na zewnątrz.",
        },
    },
};
